import fetchHandler from "../../utils/fetchHandler";
import { WORKOUT_PLANS } from "../types/actions";

export const fetchWorkoutPlans = (queryString) => {
	const fetchOptions = {
		url: `/api/workout_plans?${queryString}`,
		method: "GET",
		actionType: WORKOUT_PLANS.GET_WORKOUT_PLANS
	};
	return fetchHandler(fetchOptions);
};

export const searchWorkoutPlan = (queryString) => {
	const fetchOptions = {
		url: `/api/workout_plans?${queryString}`,
		method: "GET",
		actionType: WORKOUT_PLANS.SEARCH_WORKOUT_PLANS
	};
	return fetchHandler(fetchOptions);
};

export const getWorkoutPlanDetails = (queryString) => {
	const fetchOptions = {
		url: `/api/workout_plans/${queryString}`,
		method: "GET",
		actionType: WORKOUT_PLANS.GET_WORKOUT_PLAN_DETAILS
	};
	return fetchHandler(fetchOptions);
};

export const addPlanToMyWorkout = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/member_exercise_plans/add_plans_to_myworkout`,
		method: "POST",
		actionType: WORKOUT_PLANS.ADD_PLAN_TO_WORKOUT,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};
